// React entry point. Vite imports this file from index.html.
// `createRoot` is the React 18 concurrent-rendering API; the older
// `ReactDOM.render` is deprecated.
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element in index.html");

createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
